import { useState, useEffect, useCallback } from "react";
import { parseVirtualBoreParams, clearVirtualBoreParams } from "../utils";
import { VIRTUAL_BORE_EVENTS } from "../constants";

/**
 * Hook for managing virtual bore URL parameters
 * Watches for URL changes and provides state management
 */
export const useVirtualBoreUrl = () => {
  const [isDialogOpen, setIsDialogOpen] = useState(false);
  const [coordinates, setCoordinates] = useState(null);

  const checkUrlParams = useCallback(() => {
    const params = parseVirtualBoreParams();

    if (params?.coordinates) {
      setCoordinates(params.coordinates);
      setIsDialogOpen(true);
    } else {
      setIsDialogOpen(false);
      setCoordinates(null);
    }
  }, []);

  // Watch for URL parameter changes
  useEffect(() => {
    // Check on mount
    checkUrlParams();

    // Listen for URL changes
    const handlePopState = () => {
      checkUrlParams();
    };

    const handleUrlParamsChanged = () => {
      checkUrlParams();
    };

    window.addEventListener("popstate", handlePopState);
    window.addEventListener(
      VIRTUAL_BORE_EVENTS.URL_PARAMS_CHANGED,
      handleUrlParamsChanged
    );

    return () => {
      window.removeEventListener("popstate", handlePopState);
      window.removeEventListener(
        VIRTUAL_BORE_EVENTS.URL_PARAMS_CHANGED,
        handleUrlParamsChanged
      );
    };
  }, [checkUrlParams]);

  const closeDialog = useCallback(() => {
    clearVirtualBoreParams();
    setIsDialogOpen(false);
    setCoordinates(null);
  }, []);

  return {
    isDialogOpen,
    coordinates,
    closeDialog,
  };
};
